import { PublicKey } from '@solana/web3.js';
import { MarketInfo, TokenInfo } from './types';

export const MAX_PRIORITY_FEE = 10_000;
export const COMPUTE_UNIT_LIMIT = 1_000_000;
export const COMPUTE_UNIT_LIMIT_MULTIPLIER = 1.1;

export const MARKETS: MarketInfo[] = [
  {
    address: new PublicKey('8GmrrARv2SQ5Z8eKnrvJ9VrcZHDoeGmRfR5MY5jmqfuM'),
    name: 'ETH/USDC',
    programId: new PublicKey('xY9r3jzQQLYuxBycxfT31xytsPDrpacWnyswMskn16s'),
    deprecated: false,
    quoteLabel: 'USDC',
    baseLabel: 'ETH',
  },
  {
    address: new PublicKey('4riVQRGVHbwA6buZBLyBTKh7rByNQHpeua85Fcze8z5p'),
    name: 'BTC/USDC',
    programId: new PublicKey('xY9r3jzQQLYuxBycxfT31xytsPDrpacWnyswMskn16s'),
    deprecated: false,
    quoteLabel: 'USDC',
    baseLabel: 'BTC',
  },
];

export const TOKENS: TokenInfo[] = [
  {
    name: 'ETH',
    address: new PublicKey('So11111111111111111111111111111111111111112'),
  },
  {
    name: 'USDC',
    address: new PublicKey('Usdc2oYTsrjCH3KbCva8bLZwbqjcQLafAFjf5ifPNxa'),
  },
  {
    name: 'BTC',
    address: new PublicKey('2WGF5NgLZV3cg473ZNh41vzj3PU8HwLr3RB1PbyvCSXu'),
  },
];
